import * as React from "react";
import { CatalogsPage } from "src/pages/catalogs/CatalogsPage";
import { NewRecordPage } from "src/pages/catalogs/NewRecordPage";
import { RecordCardPage } from "src/pages/catalogs/RecordCardPage";
import { RecordHistoryPage } from "src/pages/catalogs/RecordHistoryPage";
import { RecordsPage } from "src/pages/catalogs/RecordsPage";
import { ClassesPage } from "src/pages/classes/ClassesPage";
import { EditClassPage } from "src/pages/classes/EditClassPage";
import { NewClassPage } from "src/pages/classes/NewClassPage";
import { ClassifiersPage } from "src/pages/classifiers/ClassifiersPage";
import { CustomTableDemo } from "src/pages/CustomTableDemo";
import { HomePage } from "src/pages/HomePage";
import { DocPage } from "src/pages/management/DocPage";
import { ExtensionCardPage } from "src/pages/management/extensions/ExtensionCardPage";
import { ExtensionsPage } from "src/pages/management/extensions/ExtensionsPage";
import { ManagementClassifiers } from "src/pages/management/objects/ManagementClassifiers";
import { ManagementClassifierAccess } from "src/pages/management/objects/ManagementClassifiers/ManagementClassifierAccess";
import { ManagementClassifierCard } from "src/pages/management/objects/ManagementClassifiers/ManagementClassifierCard";
import { ManagementPrimSpecs } from "src/pages/management/objects/ManagementPrimSpecs";
import { ManagementPrimSpecCard } from "src/pages/management/objects/ManagementPrimSpecs/ManagementPrimSpecCard";
import {
  ManagementCatalogEdit,
  ManagementCatalogNew,
  ManagementsCatalogs,
} from "src/pages/management/objects/ManagementsCatalogs";
import { ManagementCatalogAccess } from "src/pages/management/objects/ManagementsCatalogs/ManagementCatalogAccess";
import {
  ManagementSecondSpecCard,
  ManagementSecondSpecs,
} from "src/pages/management/objects/ManagementSecondSpecs";
import { ManagementValueCatalog } from "src/pages/management/objects/ManagementValueCatalog";
import { ManagValueCatalogEdit } from "src/pages/management/objects/ManagementValueCatalog/ManagValueCatalogEdit";
import { ManagValueCatalogNew } from "src/pages/management/objects/ManagementValueCatalog/ManagValueCatalogNew";
import { ValueCatalogContent } from "src/pages/management/objects/ManagementValueCatalog/ValueCatalogContent";
import { ValueCatalogRecEdit } from "src/pages/management/objects/ManagementValueCatalog/ValueCatalogContent/ValueCatalogRecEdit";
import { ValueCatalogRecNew } from "src/pages/management/objects/ManagementValueCatalog/ValueCatalogContent/ValueCatalogRecNew";
import { ManagementValueSpecs } from "src/pages/management/objects/ManagementValueSpecs";
import { ManagementValueSpecCard } from "src/pages/management/objects/ManagementValueSpecs/ManagementValueSpecCard";
import {
  RolesList,
  SingleRolePage,
} from "src/pages/management/usersAndRoles/roles";
import {
  SingleUserPage,
  UsersList,
} from "src/pages/management/usersAndRoles/users";
import { WorkflowCardPage } from "src/pages/management/workflows/WorkflowCardPage";
import { WorkflowsPage } from "src/pages/management/workflows/WorkflowsPage";
import { MdmCardDemoPage } from "src/pages/tests/MdmCardDemoPage";
import { MFormDemoPage } from "src/pages/tests/MFormDemoPage";
import { TableDemoPage } from "src/pages/tests/TableDemoPage";
import { TestPage } from "src/pages/tests/TestPage";
import { WfNewRecordPage } from "src/pages/workflow/WfNewRecordPage";
import { WfRecordCardPage } from "src/pages/workflow/WfRecordCardPage";
import { WorkflowCardsPage } from "src/pages/workflow/WorkflowCardsPage";
import { WorkflowStreamsPage } from "src/pages/workflow/WorkflowStreamsPage";

import { PageUrl } from "./PageUrl";

export const routesMap: Record<PageUrl, React.FC> = {
  [PageUrl.home]: HomePage,
  [PageUrl.test]: TestPage,
  [PageUrl.cardDemo]: MdmCardDemoPage,
  [PageUrl.tableDemo]: TableDemoPage,
  [PageUrl.customTableDemo]: CustomTableDemo,
  [PageUrl.classifiers]: ClassifiersPage,
  [PageUrl.managementCatalogs]: ManagementsCatalogs,
  [PageUrl.managementCatalogNew]: ManagementCatalogNew,
  [PageUrl.managementCatalogEdit]: ManagementCatalogEdit,
  [PageUrl.managementCatalogAccess]: ManagementCatalogAccess,
  [PageUrl.managementClassifiers]: ManagementClassifiers,
  [PageUrl.managementClassifierCard]: ManagementClassifierCard,
  [PageUrl.managementClassifierAccess]: ManagementClassifierAccess,
  [PageUrl.managementPrimSpecs]: ManagementPrimSpecs,
  [PageUrl.managementPrimSpecCard]: ManagementPrimSpecCard,
  [PageUrl.managementUsers]: UsersList,
  [PageUrl.managementRoles]: RolesList,
  [PageUrl.managementUserNew]: SingleUserPage,
  [PageUrl.managementUserEdit]: SingleUserPage,
  [PageUrl.managementRoleNew]: SingleRolePage,
  [PageUrl.managementRoleEdit]: SingleRolePage,
  [PageUrl.managementSecondSpecs]: ManagementSecondSpecs,
  [PageUrl.managementSecondSpecCard]: ManagementSecondSpecCard,
  [PageUrl.managementValueSpecs]: ManagementValueSpecs,
  [PageUrl.managementValueSpecCard]: ManagementValueSpecCard,
  [PageUrl.managementValueCatalogs]: ManagementValueCatalog,
  [PageUrl.managementValueCatalogNew]: ManagValueCatalogNew,
  [PageUrl.managementValueCatalogEdit]: ManagValueCatalogEdit,
  [PageUrl.managementWorkflows]: WorkflowsPage,
  [PageUrl.managementWorkflowNew]: WorkflowCardPage,
  [PageUrl.managementWorkflowCard]: WorkflowCardPage,
  [PageUrl.managementExtensions]: ExtensionsPage,
  [PageUrl.managementExtensionNew]: ExtensionCardPage,
  [PageUrl.managementExtensionCard]: ExtensionCardPage,
  [PageUrl.valueCatalog]: ValueCatalogContent,
  [PageUrl.valueCatalogNew]: ValueCatalogRecNew,
  [PageUrl.valueCatalogEdit]: ValueCatalogRecEdit,
  [PageUrl.classes]: ClassesPage,
  [PageUrl.newClass]: NewClassPage,
  [PageUrl.class]: EditClassPage,
  [PageUrl.mformDemo]: MFormDemoPage,
  [PageUrl.workflowStreams]: WorkflowStreamsPage,
  [PageUrl.workflowCards]: WorkflowCardsPage,
  [PageUrl.catalogs]: CatalogsPage,
  [PageUrl.records]: RecordsPage,
  [PageUrl.newRecord]: NewRecordPage,
  [PageUrl.editRecord]: RecordCardPage,
  [PageUrl.newRecordWf]: WfNewRecordPage,
  [PageUrl.editRecordWf]: WfRecordCardPage,
  [PageUrl.recordHistory]: RecordHistoryPage,
  [PageUrl.docs]: DocPage,
};

export const routes = Object.entries(routesMap);
